/**
 * "Tvrdý" refresh obrazovky denného menu.
 *
 * Na Androide / vo WebView bežný window.location.reload() často servíruje dokument aj
 * dáta z cache, takže zmena šablóny (settings.template) ani nový JS bundle sa neprejaví.
 * Preto meníme URL o cache-busting parameter (_r=<timestamp>) a nanovo načítame dokument
 * cez location.replace — iná URL = iný cache-key = čerstvý fetch index.html (a tým aj
 * najnovšieho hashovaného bundla) bez pridania záznamu do histórie.
 */
export function hardReloadScreen() {
  try {
    const url = new URL(window.location.href);
    url.searchParams.set("_r", String(Date.now()));
    window.location.replace(url.toString());
  } catch (_e) {
    // Fallback, ak by URL API zlyhalo (staré WebView).
    window.location.reload();
  }
}
